import React, { useEffect, useState } from 'react';

import image01 from '../../../Assets/Linkages/CapacityBuilding/01.jpg';
import image02 from '../../../Assets/Linkages/CapacityBuilding/02.jpg';
import image03 from '../../../Assets/Linkages/CapacityBuilding/03.jpg';
import image04 from '../../../Assets/Linkages/CapacityBuilding/04.jpg';
import image05 from '../../../Assets/Linkages/CapacityBuilding/05.jpg';
import image06 from '../../../Assets/Linkages/CapacityBuilding/06.jpg';
import image07 from '../../../Assets/Linkages/CapacityBuilding/07.jpg';
import image08 from '../../../Assets/Linkages/CapacityBuilding/08.jpg';
import image09 from '../../../Assets/Linkages/CapacityBuilding/09.jpg';
import image10 from '../../../Assets/Linkages/CapacityBuilding/10.jpg';
import image11 from '../../../Assets/Linkages/CapacityBuilding/11.jpg';
import image12 from '../../../Assets/Linkages/CapacityBuilding/12.jpg';
import image13 from '../../../Assets/Linkages/CapacityBuilding/13.jpg';
import image14 from '../../../Assets/Linkages/CapacityBuilding/14.jpg';

const images = [image01, image02, image03, image04, image05, image06, image07, image08, image09, image10, image11, image12, image13, image14];

const CapacityBuildingIntroduction = () => {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setActiveImage((current) => (current + 1) % images.length), 3000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="capacity-introduction" aria-labelledby="capacity-introduction-title">
      <div className="capacity-introduction-inner">
        <div className="capacity-introduction-copy">
          <p className="section-eyebrow">BUILDING KNOWLEDGE · DEVELOPING EXPERTISE</p>
          <h1 id="capacity-introduction-title">Introduction</h1>
          <div className="capacity-title-line" aria-hidden="true" />
          <p>
            The National Center of GIS and Space Applications (NCGSA) is committed to advancing
            capacity building through high-impact, experiential learning. Our comprehensive
            portfolio of workshops and training programs is designed to deliver practical,
            hands-on exposure across key domains including space science, satellite technology,
            geographic information systems (GIS), and related disciplines.
          </p>
          <p>
            These programs are strategically developed for students, educators, researchers,
            industry stakeholders, and professionals, equipping participants with specialized
            skills and applied knowledge to drive innovation and contribute effectively to
            Pakistan’s growing space and geospatial technology ecosystem.
          </p>
        </div>
        <div className="capacity-introduction-gallery">
          <figure className="capacity-introduction-image">
            <img src={images[activeImage]} alt={`NCGSA capacity-building activity ${activeImage + 1}`} />
          </figure>
          <div className="capacity-slider-controls">
            <button type="button" onClick={() => setActiveImage((activeImage - 1 + images.length) % images.length)} aria-label="Previous activity image">←</button>
            <span>{String(activeImage + 1).padStart(2, '0')} / {images.length}</span>
            <button type="button" onClick={() => setActiveImage((activeImage + 1) % images.length)} aria-label="Next activity image">→</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CapacityBuildingIntroduction;
